import { render, staticRenderFns } from "./AppWithLoading.vue?vue&type=template&id=c05fdc0c&scoped=true&"
import script from "./AppWithLoading.vue?vue&type=script&lang=js&"
export * from "./AppWithLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05fdc0c",
  null
  
)

export default component.exports